export const TYPES_OF_CARD = {
    ARTICLE: 'article',
    LEARNING: 'learning',
} as const;

export type TYPE_OF_CARD = typeof TYPES_OF_CARD[keyof typeof TYPES_OF_CARD];
